import { HelpCircle } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgHelp = mkIcon(HelpCircle);